/**
 * ALERT-NOTICE.JS
 */

import Cookies from 'js-cookie';
import Slideable from '../classes/slideable';

const COOKIE_IDENTIFIER = 'alert-noticed';

export default class AlertNotice {

	/**
	 * Initializes the alert notice in the header navigation menu.
	 */
	static init() {
		return new AlertNotice();
	}

	constructor() {
		const mainElement = document.getElementById('alert-notice');
		const slideableMainElement = new Slideable(mainElement);

		if (mainElement === null)
			return;

		this.initCloseButton(mainElement, slideableMainElement);
		this.initToggles(mainElement, slideableMainElement);
		this.initLink(mainElement, slideableMainElement);

		if (Cookies.get(COOKIE_IDENTIFIER) !== 'true')
			slideableMainElement.down();
	}

	/**
	 * Enables hiding the alert notice using the close button
	 */
	initCloseButton(alertNoticeElement, slideableAlertNoticeElement) {
		if (alertNoticeElement === null)
			return;

		const closeButton = alertNoticeElement.querySelector('.alert-notice__close-button');

		closeButton.addEventListener('click', () => {
			slideableAlertNoticeElement.up();
			Cookies.set(COOKIE_IDENTIFIER, 'true');
		});
	}

	/**
	 * Enables toggling the alert notice using an element which has following attribute set to true:
	 * [data-toggle-alert-notice="true"]
	 */
	initToggles(alertNoticeElement, slideableAlertNoticeElement) {
		if (alertNoticeElement === null)
			return;

		const toggleButtons = document.querySelectorAll('[data-toggle-alert-notice="true"]');

		if (toggleButtons.length === 0)
			return;

		toggleButtons.forEach((toggleButton) => {
			toggleButton.addEventListener('click', () => {
				Cookies.set(COOKIE_IDENTIFIER, slideableAlertNoticeElement.isHidden() ? 'false' : 'true');
				slideableAlertNoticeElement.toggle();
			});
		});
	}

	/**
	 * Sets the cookie to shown, once the alert notice is clicked
	 */
	initLink(alertNoticeElement) {
		if (alertNoticeElement === null)
			return;

		const link = alertNoticeElement.querySelector('.alert-notice__link');

		if (!link)
			return;

		link.addEventListener('click', () => {
			Cookies.set(COOKIE_IDENTIFIER, 'true');
		});
	}

}